import { Component, Input } from '@angular/core';
import { ModalProps } from '@app/core/components/modal';
import { PcsModalDirective } from '@app/core/components/modal/modal';
import { CloseModal } from '@app/core/pcs-modal';
import { PcsTranslateService } from '@app/core/translate/translate.service';
import { Store } from '@ngrx/store';


@Component({
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['../base-confirmation-modal-component.scss']
})
export class ConfirmationModalComponent extends PcsModalDirective {
  @Input() props: ModalProps;

  constructor(protected store: Store<any>,
    protected translateService: PcsTranslateService) {
    super(store, translateService);
  }

  onConfirm() {
    super.onConfirm();
    this.store.dispatch(new CloseModal());
  }

}
